import { FC, useRef, useState } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import { useTranslation } from "react-i18next";
import { FullWidthLayout } from "@/layouts";
import { HomeTitle } from "@/components/ui";
import { CardSlider } from "./goalComponents";
import { TitleContainer, SectionTitle } from "../home.styles";
import * as Styled from "./ourGoal.styles";

interface OurGoalProps {
  selecteditem: number;
}

const slideItema = ["owners", "operators", "suppliers", "energyTrader"];

const OurGoal: FC<OurGoalProps> = ({ selecteditem }) => {
  const { t } = useTranslation("global");
  const ref = useRef();
  const { events } = useDraggable(ref as any);

  const [active, setActive] = useState("");

  const handleClick = (item: string) => {
    if (active === item) {
      setActive("");
    } else {
      setActive(item);
    }
  };

  return (
    <FullWidthLayout id="goal">
      <Styled.GoalContainer>
        <Styled.TextContainer>
          <TitleContainer>
            <HomeTitle
              className="headline-small weight-medium"
              color={selecteditem === 6 || selecteditem === 7 ? "var(--primary-dark)" : "var(--primary-light)"}
              borderColor={selecteditem === 6 || selecteditem === 7 ? "var(--primary-dark)" : "var(--primary-light)"}
            >
              {t("ourGoalTitle.title")}
            </HomeTitle>
            <SectionTitle className="display-large" color={selecteditem === 6 || selecteditem === 7 ? "var(--on-surface-dark)" : "var(--on-surface-light)"}>
              {t("ourGoalTitle.description")}
            </SectionTitle>
          </TitleContainer>
        </Styled.TextContainer>
        <Styled.SlideContainer {...events} ref={ref}>
          {slideItema.map((item, i) => (
            <CardSlider key={i} idx={i} item={item} active={active} handleClick={handleClick} />
          ))}
        </Styled.SlideContainer>
      </Styled.GoalContainer>
    </FullWidthLayout>
  );
};

export default OurGoal;
